<div [style.marginTop]="reportCustomElemet.top"  *ngIf="(!designService.customElementAdd && !designService.isClickedOnCEUpdate) else AddElement" class="table-container mark" [ngStyle]="getContainerStyle(reportCustomElemet)" (click)="onClick($event)" [ngClass]="{
    'dynamic-mark': true,
    'selectable': reportCustomElemet.isSelectable,
    'selected': reportCustomElemet.isSelected,
    'edited': !reportCustomElemet.isSaved(),
    'highlight-hover' : designService.highlightElement }">
  <div style="height: 9mm; padding: 0 5mm; font-weight:bold" [style.fontSize]="reportCustomElemet.titleFontSize" [style.textAlign]="reportCustomElemet.titleAlign"
         [style.backgroundColor]="reportCustomElemet.titleBackgroundColor">{{ reportCustomElemet.titleText }}<span><button *ngIf="isNewApp" mat-icon-button (click)="onCustomElementEdit()"><mat-icon>edit</mat-icon></button></span></div>
  <div class="my-2">
    <span>{{'customElement.name' | translate}}:<strong>{{reportCustomElemet.designElementName}}</strong></span>
  </div>

  <div [ngStyle]="getStyles(reportCustomElemet)">
    <img alt="Custom Element">
  </div>
</div>
<ng-template #AddElement>
  <div class="container" (click)="onClick($event)" [style.marginTop]="reportCustomElemet.top" [ngStyle]="getContainerStyle(reportCustomElemet)" style="background-color: lightgoldenrodyellow; border: 1px solid #e9b226;">
    <mat-toolbar color="primary"  class="toolbar-CE">
      <mat-label>{{'customElement.name' | translate}}</mat-label>
      <input matInput class="name" [(ngModel)]="customElementName">
      <mat-divider  [vertical]="true" class="divider"></mat-divider>
      <mat-select class="ml-1" [(ngModel)]="application" (ngModelChange)="changeApplication()" disableOptionCentering>
        <mat-option *ngFor="let application of applications" [value]="application">
          {{application}}
        </mat-option>
      </mat-select>
      <button mat-icon-button (click)="onsave()" class="save-button" [disabled]="(!customElementName || !application)">
        <mat-icon>save</mat-icon>
      </button>
      <button mat-icon-button class="delete-button" (click)="deleteElement()">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-toolbar>

    <div [ngClass]="{
      'body': true,
      'mark-body': true
    }" [style.height]="'100mm'">
      <div class="add-element" [style.top]="getLastElementYPosition()">
      <button mat-icon-button [matMenuTriggerFor]="addElement">
        <mat-icon class="addIcon">add</mat-icon>
      </button>
      <mat-menu #addElement="matMenu" yPosition="below">
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('section', 'draw')"><mat-icon>extension</mat-icon>{{'customElement.section' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('text', 'draw')"><mat-icon>title</mat-icon>{{'customElement.text' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('line', 'draw')"><mat-icon>remove</mat-icon>{{'customElement.line' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('image', 'draw')"><mat-icon>image</mat-icon>{{'customElement.image' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('rectangle', 'draw')"><mat-icon>crop_7_5</mat-icon>{{'customElement.rectangle' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('table', 'draw')"><mat-icon>grid_on</mat-icon>{{'customElement.table' | translate}}</button>
        <button mat-menu-item class="mat-menu-item" (click)="onSelectObjectMenu('dropDownList', 'draw')"><mat-icon>list_alt</mat-icon>{{'customElement.dropdownList' | translate}}</button>
      </mat-menu>
    </div>
    </div>

  </div>

</ng-template>


